<template>
<div>
<div >
   <div v-if="!isBrokerDealer && !isTradeRecap">
      <a v-if="isAdmin || isEditor || isTrader || isOperator || isSuperAdmin" style="margin-left: 49px;padding: 0;" @click="showBidAcceptOrRejectPopup()" class="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
         <span class="ntn-badge bid">BID</span>
         <i  v-bind:class="notificationReceived ? 'bell-ring' : ''" class="fas fa-bell fa-2x"></i>
      </a>
      <a v-if="isAdmin || isEditor || isTrader || isOperator || isSuperAdmin" @click="showOfferAcceptOrRejectPopup()" class="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
         <span class="ntn-badge offr">OFFER</span>
         <i  v-bind:class="notificationReceived ? 'bell-ring' : ''" class="fas fa-bell fa-2x"></i>
      </a>
      <a style="margin-left: -20px;" v-if="isAdmin || isEditor || isTrader || isOperator || isSuperAdmin" @click="showAutoBidAcceptOrRejectPopup()" class="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
         <span class="ntn-badge autobid">BUYS</span>
         <i  v-bind:class="notificationReceived ? 'bell-ring' : ''" class="fas fa-bell fa-2x"></i>
      </a>
      <a v-if="isRiskManager || isSuperAdmin" @click="goToCompliaceAlertPageAB()" class="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
         <span class="ntn-badge compliance" v-bind:style="{ left: (isAdmin || isEditor || isTrader || isOperator || isSuperAdmin) ? '182px' : '-5px' }" >COMPLIANCE</span>
         <i  v-bind:class="notificationReceived ? 'bell-ring' : ''" class="fas fa-bell fa-2x">
            <span v-if="complianceNotificationCount" class="notification-count">{{complianceNotificationCount}}</span>
         </i>
      </a>
   </div>
   <div v-if="(isBrokerDealer) && !isTradeRecap">
      <a  @click="goToCompliaceAlertPageBD()" class="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
         <span class="ntn-badge compliance" style="left: -5px;">COMPLIANCE</span>
         <i  v-bind:class="notificationReceived ? 'bell-ring' : ''" class="fas fa-bell fa-2x">
            <span v-if="complianceNotificationCount" class="notification-count">{{complianceNotificationCount}}</span>
         </i>
      </a>
   </div>
   <BidAcceptOrRejectPopup  
      v-if="BidAcceptModalOpen" 
      @close="BidAcceptModalOpen = false"
      />
   <TmcPriceUpdatePopup 
       v-if="tmcModalOpen" 
      @close="tmcModalOpen = false"
   /> 
   <audio id="myAudio">
      <source src="https://imsalarmsounds.s3.amazonaws.com/TF016.WAV" type="audio/ogg">
   </audio>
</div>
</div>
</template>
<script>
import SockJS from "sockjs-client";
 import Stomp from "webstomp-client";
//import Stomp from "stompjs";
import authService from "@/authService";
import config from "@/config";
import BidAcceptOrRejectPopup from "./BidAcceptOrRejectPopup";
import TmcPriceUpdatePopup from "./TmcPriceUpdatePopup";
import pingService from "@/pingService";

export default {
  name: "tradernotification",
   components: {
      BidAcceptOrRejectPopup,
      TmcPriceUpdatePopup,
      
  },
  watch:{
    $route (){
      this.isTradeRecap = window.location.pathname.includes('traderecap');
    }
  } ,
  data() {
    return {
      notificationList:[],
      notificationReceived:false,
      unreadCount : 0,
      BidAcceptModalOpen : false,
      tmcModalOpen : false,
      isProduction : window.location.hostname === "www.drlgroup.app",
      stompClient : null,
      isAdmin: false,
      isTrader : false,
      isEditor : false,
      isSuperAdmin : false,
      isBrokerDealer : false,
      complianceNotificationCount : 0,
      isRiskManager : false,
      isOperator : false,
      isTradeRecap : window.location.pathname.includes('traderecap'),


    };
  },
  methods: {
   connect() {
      let cognitoSub = this.cognitoSub;
      let subUrl = this.isProduction ? "/user/"+cognitoSub+"/queue/notification/tradebook-bidside" : "/user/"+cognitoSub+"/queue/notification/demo"
      let self = this;
      let socket = new SockJS(config.baseUrlBidSide+config.websocketConnection);
         this.stompClient = Stomp.over(socket);
         this.stompClient.debug = () => {};
         this.stompClient.connect({},function() {
               //console.log("BID SIDE WEBSOCKET Connected: ");
               self.$root.$emit("websocketconnected",{show : true});
               self.stompClient.subscribe(subUrl, function(val) {
                  //console.log(val);
                  if(JSON.parse(val.body).message == 'new notification added'){
                     self.getNotifications();
                     self.notificationReceived = true;
                  }
                  if(JSON.parse(val.body).message == 'user role changed'){
                     self.$alert("Your current user role is changed. Please log out and log in again to view the changes.","","warning");
                  }
                  if(JSON.parse(val.body).message == 'NEW ORDER RECIEVED' || JSON.parse(val.body).message == 'BIDALERT STATUS CHANGED'){
                     self.showBidAcceptOrRejectPopup();
                     self.playSound();
                     self.notificationReceived = true;

                  }
                  if(JSON.parse(val.body).message == 'CURVE YIELD CHANGE'){
                     // self.showTmcPriceUpdatePopup();
                     // self.playSound()
                  }
                  if(JSON.parse(val.body).status == 'SUCCESS'){
                     self.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'BID SUCCESSFUL',
                        text: JSON.parse(val.body).message,
                        duration: 10000,
                     
                     });
                  }
                  if(JSON.parse(val.body).status == 'FAIL'){
                     self.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'BID FAILED',
                        text: JSON.parse(val.body).message,
                        duration: 10000,
                     });
                  }
                  if(JSON.parse(val.body).status == 'WARNING'){
                     self.$notify({
                        group: 'foo',
                        type: 'warn',
                        title: 'BID WARNING',
                        text: JSON.parse(val.body).message,
                        duration: 10000,
                     });
                  }
               });
            },function(){
               //console.log('STOMP: ' + error);
               if(authService.getUser()){
                  self.$root.$emit("websocketconnected",{show : false});
                  setTimeout(function(){ self.connect()},5000);
                  //console.log('STOMP: Reconecting ');
               }
               
            }
         );
      },
      disconnect(){
         if (this.stompClient != null) {
            this.stompClient.disconnect();
            console.log("Disconnected");
         }
      },
      test(){
         const auth = {
         headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
         };
         this.$http
         .get(
            config.baseUrlBidSide + '/alert/add-to-queue?cognitoSub='+this.cognitoSub,
               auth
         )
         .then(() => {
         })
      },
      getNotifications(){
         const auth = {
         headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
         };
         this.$http
         .get(
            config.baseUrlBidSide + '/alert/list?status=ACTIVE,READ&cognitoSub='+this.cognitoSub,
               auth
         )
         .then(result => {
            this.notificationList = result.data;
            var self = this;
            self.notificationReceived = false;
            self.unreadCount = 0;
            this.notificationList.forEach(function(value){
               if(value.status == 'ACTIVE'){
                  self.notificationReceived = true;
                  self.unreadCount++;
               }
            });
         })
      },
      setNotificationAsRead(id){
         const auth = {
         headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
         };
         this.$http
         .put(
            config.baseUrlBidSide + '/alert/update',
               {
                  "id":id,
                  "status":"READ"
               },
               auth
         )
         .then(() => {
            this.getNotifications();
         })
      },
      markAllAsRead(){
         const auth = {
         headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
         };
         this.$http
         .put(
            config.baseUrlBidSide + '/alert/update-all',
               {
                  "cognitoSub":this.cognitoSub,
                  "status": "READ"
               },
               auth
         )
         .then(() => {
            this.getNotifications();
         })
      },
      checkBidIsWaiting(){
         const auth = {
         headers: {'org-token' : authService.getOrgToken()  }
         };
         this.$http
         .get(
            config.baseUrlBidSide +
               "/bid/list-waiting?page=1&size=5&search=&status=WAITING&sortColumn=latestDate&sortOrder=DESC&cognitoSub="+
               this.cognitoSub,
               auth

         )
         .then(result => {
               if(result.data.content.length != 0 ){
                  this.showTmcPriceUpdatePopup();
                  this.playSound()
               }
         })
      },
      checkAcceptOrRejectBidIsWaiting(){
         const auth = {
         headers: {'org-token' : authService.getOrgToken() }
         };
         var fDate = this.moment(this.moment().subtract(1,'days').format("YYYY-MM-DD")).utc().format("YYYY-MM-DD HH:mm:ss");
         var tDate = this.moment(this.moment().add(2,'days').format("YYYY-MM-DD")).utc().format("YYYY-MM-DD HH:mm:ss");
         var subId = (!this.isSuperAdmin && this.isTrader) ? this.cognitoSub : "";
         let url = ""
         if(subId){
            url = '/bid-alerts/list?cognitoSub='+this.cognitoSub;
         }else{
            url = '/bid-alerts/list?';
         }
         this.$http
         .get(
            config.baseUrlBidSide + url+
            '&status=UNREAD'+
            "&fromDate="+
            fDate+
            "&toDate="+
            tDate,
            auth
         )
         .then(result => {
            console.log(result.data.content.length)
            if(result.data.content.length != 0 ){
                  this.showBidAcceptOrRejectPopup();
                  this.playSound();
                  this.notificationReceived = true;
               }
         })
      },
      openNotification(){
         this.notificationReceived = false;
      },
      showBidAcceptOrRejectPopup(){
         this.BidAcceptModalOpen = true;
      }, 
      showOfferAcceptOrRejectPopup(){
         this.$root.$emit("showofferacceptpopup"); 
      },
      showAutoBidAcceptOrRejectPopup(){
         this.$root.$emit("showoautobidderacceptpopup"); 
      },
      showTmcPriceUpdatePopup(){
         this.tmcModalOpen = true
      },
      playSound(){
         var x = document.getElementById("myAudio"); 
         var promise =  x.play();
         var self = this;
         if (promise !== undefined) {
            promise.then(()=> {
               // Autoplay started!
            }).catch(error => {
               self.$alert("Please allow sound/audio access to this site from your browser settings page to enable the sound feature.","","warning");
               console.log("error",error)
               // Autoplay was prevented.
               // Show a "Play" button so that user can start playback.
            });
         } 
      },
      getComplianceNotificationCount(){
         const auth = {
         headers: {'org-token' : authService.getOrgToken()  }
         };
         this.$http
         .get(
            config.baseUrlAutoBidder +
               "/autobidder/compliance-notification-count?cognitoSub="+
               authService.getUser().cognitoSub,
               auth

         )
         .then(result => {
            this.complianceNotificationCount = result.data.count;
         })
      },
      goToCompliaceAlertPageBD(){
         this.$router.push("/brockerdealer/alert");
      },
      goToCompliaceAlertPageAB(){
         this.$router.push("/autobidder/alert");
      },

  },
  mounted() {
      if(localStorage.getItem("userLastSeen")){
         const unixTimestamp = Number(localStorage.getItem("userLastSeen"));
         const momentDate = this.moment(unixTimestamp);
         const currentMoment = this.moment();
         const timeDifference = currentMoment - momentDate;
         const sessionTimeout = 5 * 1000; // 5 seconds
         // Check if the time difference is greater than session time
         if (timeDifference > sessionTimeout) {
            //this.$alert("Your current session has been expired.","","error");
            pingService.stopTimer();
            this.$root.$emit("logout");
            this.$cognitoAuth.logout();
            this.$router.push({ path: "/" });
            console.log("ForceFull logout during ping check from traderNotification Page")
         } else {
            //alert('');
         }
      }
    pingService.startTimer();
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.cognitoSub = authService.getUser().cognitoSub;
        //this.getNotifications();
        this.connect();
        //this.checkBidIsWaiting();
      //   this.showBidAcceptOrRejectPopup();
      //   this.playSound();
      //   this.notificationReceived = true;
     
       
      }
    }); 
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
         this.tenantName = role[0].split("-")[0];
         var roleArray = role.map(item => {
            return  item.split("-")[1];
         })
         roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
         roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
         roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
         roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
         roleArray.includes('RiskManager')  ? this.isRiskManager = true : this.isRiskManager = false;
         roleArray.includes('Operator')  ? this.isOperator = true : this.isOperator = false;

         if(!this.isDev && (this.isTrader || this.isSuperAdmin)){
            this.checkAcceptOrRejectBidIsWaiting();
         }
         window.location.pathname.includes('brockerdealer') ? this.isBrokerDealer = true : this.isBrokerDealer = false;
         if((this.isBrokerDealer || this.isRiskManager || this.isSuperAdmin)){
            this.getComplianceNotificationCount();
         }
        }
      });
     this.$root.$on("callwebsocket", () => {
     

    });
   this.$root.$on("logout", () => {
        this.disconnect()
    });
    this.$root.$on("popupclosed", () => {
        this.notificationReceived = false;
    });
    this.$root.$on("compliancenotification", () => {
      this.getComplianceNotificationCount();
    });
    this.$root.$on("compliancenotificationreset", () => {
      this.complianceNotificationCount = 0;
    });
  },
  created(){

      
  }
};
</script>
<style >
.hidden {
  display: none !important;
}
</style>